import { useMemo } from 'react';
import { useAppContext } from '../../../app/Context';
import { usePusherChannel } from '../../../pusher';
import { PusherChannel } from '../../../pusher/types';

const useUserChannel = () => {
  const { session } = useAppContext();

  // memoized channelIdentifier is needed to avoid frequent pusher connection/disconnection
  const [userId, channelIdentifier] = useMemo(() => {
    const userId = session?.userId;

    if (!userId) return [undefined, null] as const;

    return [
      userId,
      {
        id: `private-user-${userId}`,
        name: PusherChannel.USER,
      },
    ] as const;
  }, [session?.userId]);

  usePusherChannel(userId, channelIdentifier);
};

export default useUserChannel;
